module.exports = __webpack_public_path__ + "img/setting-2.113d758b.svg";